import { type NavigationAnchor } from "@/components/layout/types";
import Title from "@/components/Title";
import { LucideProps } from "lucide-react";
import { ForwardRefExoticComponent, RefAttributes } from "react";
import { MobileNavigationItems } from "./MobileNavigationItems";

interface NavigationItemWithSubmenu {
  title: string;
  icon?: ForwardRefExoticComponent<
    Omit<LucideProps, "ref"> & RefAttributes<SVGSVGElement>
  >;
  items: NavigationAnchor[];
}

export const MobileNavigationItemWithSubmenu = ({
  title,
  icon,
  items,
}: NavigationItemWithSubmenu) => {
  const Icon = icon;

  if (items.length === 0) return null;
  return (
    <section>
      <Title level={4} className="flex gap-1 items-center">
        {Icon && <Icon className="!size-4" />}
        {title}
      </Title>
      <MobileNavigationItems
        items={items}
        className="rounded bg-slate-100 p-4"
      />
    </section>
  );
};
